import { render, staticRenderFns } from "./newly.vue?vue&type=template&id=236548de&scoped=true&"
import script from "./newly.vue?vue&type=script&lang=js&"
export * from "./newly.vue?vue&type=script&lang=js&"
import style0 from "./newly.vue?vue&type=style&index=0&id=236548de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236548de",
  null
  
)

export default component.exports